@if (label) {
  <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400">
    {{ label }} @if (control && control.hasValidator(Validators.required)) {
    <span class="text-red-600">*</span>
  }
  </label>
}
<div class="relative">
  <textarea
    [formControl]="control"
    [name]="name"
    [rows]="rows"
    placeholder="{{ placeholder }}"
    class="
    dark:bg-dark-900 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400
    focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30
    dark:focus:border-brand-800
  "
  ></textarea>
  @if (control.invalid && (control.dirty || control.touched)) {
    <span class="absolute top-1/2 right-3.5 -translate-y-1/2 text-error-500">
      <lucide-icon size="18" [name]="CircleAlert"></lucide-icon>
    </span>
  }
</div>

@if (control.invalid && (control.dirty || control.touched)) {
  <p class="text-theme-xs text-error-500 mt-1.5">
    @for (errorKey of control.errors ? Object.keys(control.errors) : []; track errorKey) {
      @if (control.errors) {
        <div>{{ errorKey | errorMessage:control.errors[errorKey] }}</div>
      }
    }
  </p>
}
